import { render } from "./AboutIndex.vue?vue&type=template&id=5e330a62"
import script from "./AboutIndex.vue?vue&type=script&lang=js"
export * from "./AboutIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__